<template>
  <div class="root">
    <span class="score">{{ score }}</span>
    <el-divider direction="vertical" class="divider"></el-divider>
    <span class="total">100</span>
  </div>
</template>

<script>
export default {
  name: "ScoreDisplay",
  computed: {
    width: function() {
      return `${this.size * 0.75} px`;
    },
    height: function() {
      return `${this.size * 0.25} px`;
    }
  },
  props: {
    score: Number,
    size: Number
  }
};
</script>

<style lang="scss" scoped>
.root {
  font-size: 36px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.45);
  margin: 16px auto;
  .divider {
    transform: rotate(20deg);
    margin: 0 16px;
    height: 56px;
  }
  .score {
    line-height: 72px;
    vertical-align: super;
  }
  .total {
    line-height: 72px;
    vertical-align: sub;
  }
}
</style>